import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'boltPattern',
  title: 'Bolt Patterns',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
    defineField({
      name: 'lug',
      title: 'Lug',
      type: 'reference',
      to: [{ type: 'lug' }],
      options: {
        disableNew: true,
      },
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'Untitled' }) {
      return {
        title,
        subtitle: 'Bolt pattern',
      }
    },
  },
})